import { UnwrapHelper } from '../UnwrapHelper';
export class UnwrapBufferHelper extends UnwrapHelper {
}

//# sourceMappingURL=UnwrapBufferHelper.js.map
